import { Button, ButtonProps } from "@mui/material";
import { useDownloadCsv } from "../hooks/useDownloadCsv";

interface DownloadCsvButtonProps {
    path: string;
    filter: any;
    variant?: ButtonProps["variant"];
    sx?: ButtonProps["sx"];
    startIcon?: ButtonProps["startIcon"];
}

export const DownloadCsvButton: React.FC<DownloadCsvButtonProps> = ({ path, filter, variant = "contained", sx = { mb: 2 }, startIcon }) => {
    const downloadCsv = useDownloadCsv(path, filter);
    return (
        <Button
            variant={variant} sx={sx} startIcon={startIcon}
            onClick={downloadCsv}
        >
            Download CSV
        </Button>
    );
}